import React, { useState, useEffect } from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'
import authRoutes from './authRoutes'
import submissionRoutes from './submissionRoutes'
import wicRoutes from './wicRoutes'
import { useOktaAuth } from '@okta/okta-react'

const LayoutRoutes = () => {
  const { authState } = useOktaAuth()

  const [routes, setRoutes] = useState(authRoutes)
  const location = useLocation()

  useEffect(() => {
    console.log(authState?.isAuthenticated)
    console.log(location.pathname)
    if (authState?.isAuthenticated && location.pathname !== '/auth/logout') {
      const userToken = JSON.parse(localStorage.getItem('okta-token-storage'))
      setRoutes(
        userToken.accessToken.claims.role.includes('reviewer')
          ? wicRoutes
          : submissionRoutes
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState?.isAuthenticated])

  const getRoutes = routes =>
    routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views)
      }
      if (prop.layout === '/auth' || prop.layout === '/submission') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      }
      return null
    })

  return <Switch>{getRoutes(routes)}</Switch>
}

export default LayoutRoutes
